import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type { ViewComponent } from "@frui.ts/views/dist";
import { Check, Input } from "@frui.ts/bootstrap";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import LicensePlateInput from "controls/licensePlateInput";
import DatePickerBox from "controls/datePickerBox";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import CountrySelect from "views/common/countrySelect";
import type EditExemptionViewModel from "viewModels/callCenter/search/exemptions/editExemption/editExemptionViewModel";

const EditExemptionFormSection: ViewComponent<EditExemptionViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} target={vm.item.vehicle} property="countryId">
          <FormLabel>{vm.translate("countryId")}</FormLabel>
          <CountrySelect disabled={!vm.isExemptionEditable} vm={vm.countrySelectViewModel} allowEmpty={true} />
        </FormGroup>
        <FormGroup as={Col} target={vm.item.vehicle} property="licensePlate">
          <FormLabel>{vm.translate("licensePlate")}</FormLabel>
          <LicensePlateInput disabled={!vm.isExemptionEditable} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="validSince">
          <FormLabel>{vm.translate("validSince")}</FormLabel>
          <DatePickerBox disabled={!vm.isExemptionEditable} disabledShowTime placeholder={vm.translate("validSince")} />
        </FormGroup>
        <FormGroup as={Col} target={vm.item} property="validUntil">
          <FormLabel>{vm.translate("validUntil")}</FormLabel>
          <DatePickerBox
            disabled={
              ((vm.isImmediateCancellation || !vm.isExemptionEditable) && vm.isValidUntilDisabled) || vm.isImmediateCancellation
            }
            disabledShowTime
            placeholder=""
          />
        </FormGroup>
      </Form.Row>
      <Form.Row className="d-flex justify-content-end">
        <FormGroup as={Col} sm={6} xs={6} target={vm.item} property="isImmediateCancellation" className="mt-3">
          <Check disabled={vm.isValidUntilDisabled} custom type="checkbox" label={vm.translate("isImmediateCancellation")} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="exemptionReasonId">
          <FormLabel>{vm.translate("exemptionReasonId")}</FormLabel>
          <AdvancedSelect
            className="autoHeight"
            disabled={!vm.isExemptionEditable}
            items={vm.exemptionReasonOptions}
            formatOptionLabel={(data: any) => {
              return <span dangerouslySetInnerHTML={{ __html: data.label }} />;
            }}
            mode="key"
          />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="creationRecordId">
          <FormLabel>{vm.translate("creationRecordId")}</FormLabel>
          <Input errorMessage={vm.officialRecordIdError} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="cancellationRecordId">
          <FormLabel>{vm.translate("cancellationRecordId")}</FormLabel>
          <Input errorMessage={vm.officialRecordIdError} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="vehicleRegistrationChangeRecordId">
          <FormLabel>{vm.translate("officialRecordId")}</FormLabel>
          <Input disabled errorMessage={vm.officialRecordIdError} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="cancellationReason">
          <FormLabel>{vm.translate("cancellationReason")}</FormLabel>
          <Input as="textarea" rows={4} errorMessage={vm.officialRecordIdError} />
        </FormGroup>
      </Form.Row>
    </>
  );
});

export default EditExemptionFormSection;
